import { readContract } from '@wagmi/core';
import { abi as pctPairAbi } from './pct_pair_abi';
import addresses from './addresses';

import { config } from './walletConfig';

/**
 * 获取Pair合约储备量（reserve0, reserve1）
 * @returns {Promise<{reserve0: string, reserve1: string, blockTimestampLast: number}>}
 */
export async function getPairReserves() {
  try {
    const [reserve0, reserve1, blockTimestampLast] = await readContract(config, {
      abi: pctPairAbi,
      address: addresses.pctPairContractAddress, // 请确保在addresses中配置了pair合约地址
      functionName: 'getReserves',
      args: []
    });
    return { reserve0, reserve1, blockTimestampLast };
  } catch (error) {
    console.error('获取Pair储备量失败:', error);
    throw error;
  }
}

/**
 * 获取Pair合约的token0地址
 */
export async function getPairToken0() {
  try {
    return await readContract(config, {
      abi: pctPairAbi,
      address: addresses.pctPairContractAddress,
      functionName: 'token0',
      args: []
    });
  } catch (error) {
    console.error('获取token0失败:', error);
    throw error;
  }
}

/**
 * 获取Pair合约的token1地址
 */
export async function getPairToken1() {
  try {
    return await readContract(config, {
      abi: pctPairAbi,
      address: addresses.pctPairContractAddress,
      functionName: 'token1',
      args: []
    });
  } catch (error) {
    console.error('获取token1失败:', error);
    throw error;
  }
}

/**
 * 获取Pair合约的总供应量
 */
export async function getPairTotalSupply() {
  try {
    return await readContract(config, {
      abi: pctPairAbi,
      address: addresses.pctPairContractAddress,
      functionName: 'totalSupply',
      args: []
    });
  } catch (error) {
    console.error('获取totalSupply失败:', error);
    throw error;
  }
} 